/**
 * @generated SignedSource<<fc2681f69cbeb2357b6c9f260807ebd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageHeader_translations$data = ReadonlyArray<{
  readonly language: string | null | undefined;
  readonly url: string | null | undefined;
  readonly " $fragmentType": "PageHeader_translations";
}>;
export type PageHeader_translations$key = ReadonlyArray<{
  readonly " $data"?: PageHeader_translations$data;
  readonly " $fragmentSpreads": FragmentRefs<"PageHeader_translations">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PageHeader_translations",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "type": "Translation",
  "abstractKey": null
};

(node as any).hash = "c12f202d3133c4c726a3a68261b5380c";

export default node;
